import { render, staticRenderFns } from "./TextButtonView.vue?vue&type=template&id=363b9511&scoped=true&"
import script from "./TextButtonView.vue?vue&type=script&lang=ts&"
export * from "./TextButtonView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b9511",
  null
  
)

export default component.exports